/**
 * バイタル・食事データのフォーマット用ユーティリティ関数
 */

/**
 * 食事摂取量を「完食」「〜割」「なし」形式にフォーマット
 * @param intake - 摂取量（0-10の整数、nullまたはundefined可）
 * @returns フォーマットされた文字列
 *
 * @example
 * formatMealIntake(10) // => '完食'
 * formatMealIntake(7)  // => '7割'
 * formatMealIntake(0)  // => '-'
 * formatMealIntake(null) // => ''
 */
export const formatMealIntake = (intake?: number | null): string => {
  if (intake == null) return '';
  if (intake === 0) return '-';
  if (intake === 10) return '完食';
  return `${intake}割`;
};

/**
 * 複数の食事摂取量から平均を計算し、フォーマット
 * @param intakes - 摂取量の配列
 * @returns フォーマットされた平均値
 */
export const formatAverageMealIntake = (intakes: number[]): string => {
  if (intakes.length === 0) return 'なし';
  const avg = Math.round(intakes.reduce((sum, val) => sum + val, 0) / intakes.length);
  return formatMealIntake(avg);
};
